'use strict';

function getPlanAheadCarousel(data) {
  let url = '/browse/search/planner?';
  let csrf = data.csrf
  let i = 0;
  for (const [k, v] of Object.entries(data)) {
    url += i === 0 ? `${k}=${v}` : `&${k}=${v}`;
    i++;
  }
  url += `&_csrf=${csrf}`;
  return fetch(url)
    .then(res => {
      if (res.status > 200) {
        return Promise.reject(res);
      } else {
        return Promise.resolve(res);
      }
    })
    .then(res => res.json());
}

module.exports = {
  getPlanAheadCarousel,
};